import { motion } from "framer-motion";
import { skills } from "../data/skills";
import { container, itemUp } from "../Utils/framerMotionVariants";
import SkillSet from "./SkillSet";

const Skills: React.FC = () => {
  return (
    <section id="skills" className="mt-20 scroll-mt-28">
      <motion.div
        initial="hidden"
        whileInView="show"
        viewport={{ once: true }}
        variants={container}
      >
        <motion.h2
          variants={itemUp}
          className="text-2xl font-semibold text-cyan-700"
        >
          Technical Skills
        </motion.h2>
        <div className="mt-8">
          {skills.map((skill) => (
            <SkillSet skill={skill} />
          ))}
        </div>
      </motion.div>
    </section>
  );
};

export default Skills;
